"use client";
import { jsx as c } from "react/jsx-runtime";
import { memo as e } from "react";
import o from "../components/Icon/SvgIcon.js";
const m = (l) => /* @__PURE__ */ c(
  o,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m20.73 8.62 1.97 3.79v.02c.2.38.3.8.3 1.22v2.24c0 .9-.72 1.63-1.62 1.63h-.25a2.37 2.37 0 0 1-2.29 1.76c-1.1 0-2.02-.75-2.29-1.76H9.87a2.37 2.37 0 0 1-2.29 1.76c-1.1 0-2.02-.75-2.29-1.76h-.25c-1.03 0-1.87-.84-1.87-1.87v-.71H1.45c-.25 0-.45-.2-.45-.45s.2-.45.45-.45h1.72v-.87H2.11c-.25 0-.45-.2-.45-.45s.2-.45.45-.45h1.06v-5.4C3.17 5.84 4.01 5 5.04 5h9c1.03 0 1.87.84 1.87 1.87v1.08h3.52c.46 0 .9.2 1.21.54.04.04.09.13.09.13M6.42 16.88a1.15 1.15 0 1 0 2.3 0 1.15 1.15 0 0 0-2.3 0m-.84-6.36a3.93 3.93 0 1 0 7.861-.001 3.93 3.93 0 0 0-7.861.001m12.11 6.36a1.14 1.14 0 1 0 2.279.001 1.14 1.14 0 0 0-2.279-.001m.85-3.65h2.53c.37 0 .61-.4.44-.73l-.9-1.74a.48.48 0 0 0-.44-.27h-1.63c-.28 0-.5.22-.5.5v1.74c0 .28.22.5.5.5m-7.7-.83c.08.07.17.1.26.1.1 0 .2-.03.27-.11.14-.15.14-.39-.01-.53l-1.53-1.47V8.23a.37.37 0 1 0-.74 0v2.32c0 .1.04.2.11.27z",
        clipRule: "evenodd"
      }
    )
  }
), t = e(m);
export {
  t as TruckSameDayFilled,
  t as default
};
